import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Repeat, CheckCircle2, AlertCircle } from "lucide-react";

export function AdminRebook() {
  const [days, setDays] = useState(null);
  const [draft, setDraft] = useState("");
  useEffect(() => { api.get("/admin/settings").then((r) => { setDays(r.data.rebook_days); setDraft(String(r.data.rebook_days)); }).catch(() => {}); }, []);
  if (days === null) return null;

  const save = async (value) => {
    const fd = new FormData(); fd.append("rebook_days", value);
    try { const r = await api.put("/admin/settings", fd); setDays(r.data.rebook_days); setDraft(String(r.data.rebook_days)); toast.success(r.data.rebook_days ? `Rebook nudges on — ${r.data.rebook_days} days after a session` : "Rebook nudges off"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Could not save"); }
  };
  const on = days > 0;

  return (
    <div className="dg-card rounded-xl p-5" data-testid="admin-rebook">
      <div className="flex items-center gap-2">
        {on ? <CheckCircle2 className="w-4 h-4 text-emerald-400" /> : <AlertCircle className="w-4 h-4 text-amber-400" />}
        <div className="dg-eyebrow flex items-center gap-1"><Repeat className="w-3 h-3" /> Repeat-customer nudges</div>
        <span className="dg-chip ml-auto" data-testid="rebook-status-chip">{on ? `On · ${days} days after` : "Off"}</span>
      </div>
      <p className="text-sm text-slate-400 mt-2">A friendly "Everything still running smoothly?" email with a Book David again button goes to each past customer this many days after their session — only if they haven't booked again since. One nudge per customer.</p>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <input type="number" min="0" max="365" className="dg-input w-24 text-sm" value={draft} onChange={(e) => setDraft(e.target.value)} data-testid="rebook-days-input" />
        <span className="text-sm text-slate-400">days after the session</span>
        <button type="button" onClick={() => save(draft)} className="dg-btn-primary rounded-full px-5 py-2 text-sm" data-testid="rebook-save">Save</button>
        <button type="button" onClick={() => save(on ? 0 : 90)} className="dg-btn-ghost rounded-full px-5 py-2 text-sm" data-testid="rebook-toggle">{on ? "Turn off" : "Turn on (90 days)"}</button>
      </div>
    </div>
  );
}
